import myRequest from '@/utils/request'
import axios from 'axios'
import { getToken, removeToken } from '@/utils/auth'
import Message from 'element-ui/lib/message'
import MessageBox from 'element-ui/lib/message-box'
import Loading from 'element-ui/lib/loading'

//分页查询，查询结果字段全部是小写
export function Page(params) {
  return myRequest({
    url: '/Common/NewPage',
    method: 'get',
    params
  })
}
//直接根据sql查询结果
export function List(params) {
  return myRequest({
    url: '/Common/Quest',
    method: 'get',
    params
  })
}
//直接根据sql查询结果
export function Update(params) {
  return  axios({
      url:process.env.VUE_APP_BASE_API+'/Common/SetObjData',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/form-data',
        'X-Token': getToken()
      }      
    })
   
}
//直接根据sql查询结果
export function filtDown(params) {
  Loading.service('options');
let loadingInstance = Loading.service('options');
  axios({
    url:process.env.VUE_APP_BASE_API+'/Common/ExportExcel',
    method: 'post',
    data: params,
    headers:{
      // 'Content-Type': 'application/form-data',
      'X-Token': getToken()
    }      
  })
  .then(respanse=>{   
    if(respanse.data.code==200){
      Message({
        message:'导出成功！',
        type: 'success',
        duration: 2 * 1000,
        customClass:'mesInfo'
      })
    
      loadingInstance.close();
   
    }else{
      Message({
        message:'导出失败！',
        type: 'warning',
        duration: 2 * 1000,
        customClass:'mesInfo'
      })
      loadingInstance.close();
    }
  }).catch(err=>{
    Message({
      message:'导出失败！',
      type: 'warning',
      duration: 2 * 1000,
      customClass:'mesInfo'
    })
    loadingInstance.close();
  })    
}



//直接根据sql查询单个结果
export function Single(params) {
  return myRequest({
    url: '/Common/Single',
    method: 'get',
    params
  })
}

//根据编码生成下拉框-读取字典
export function Select(params) {
  return myRequest({
    url: '/Common/Select',
    method: 'get',
    params
  })
}

//批量初始化下拉框-读取字典
export function BatchSelect(params) {
  return myRequest({
    url: '/Common/BaInitSelect',
    method: 'Post',
    data: params
  })
}

//初始化下拉框-根据编码查询，结果拼接
export function BatchDataSoureSelect(params) {
  return myRequest({
    url: '/Common/DataSoureSelect',
    method: 'post',
    data: params
  })
}
export function DataSoureSelect(params) {
  return myRequest({
    url: '/Common/DsSelect',
    method: 'get',
    params
  })
}

//初始化树形下拉框
export function TreeSelect(params) {
  return myRequest({
    url: '/Common/TreeSelect',
    method: 'get',
    params
  })
}

//获取助记码
export function GetZjm(chValue) {
  var params = {};
  params.name = chValue;
  params.pagecode = "Select_Zjm";
  return myRequest({
    url: '/Common/Single',
    method: 'get',
    params
  });
}


//根据类型获取编号
export function GetCode(type) { 
  var params = {}
  params.Type = type; 
  params.pagecode = "GetCodeByType";
  return myRequest({
    url: '/Common/Single',
    method: 'get',
    params
  });
}

//根据类型获取编号
export function NewGetCode(params) { 
	params.pagecode = "GetCodeByType";
	return myRequest({
	url: '/Common/Single',
	method: 'get',
	params
	});
}